 export const skillsData = [
    'HTML',
    'Javascript',
    'CSS',
    'React',
    'NodeJS',
    'Docker',
    'Bootstrap',
    'C',
    'Python',
    'Java',
    'Git',
    'MongoDB',
    'Tailwind',
    'ViteJS',
    'MySQL',
    'PostgreSQL',
    'Numpy',
    'Pytorch',
    'Tensorflow'
]

// Choose your skills from below. Make sure it's in the same format and spelled correctly.
// Couldn't find the required skills? Raise an issue on github at https://github.com/hhhrrrttt222111/developer-portfolio/issues/new


// AVAILABLE SKILLS

/* 
    HTML
    CSS
    JS 
    React
    Node JS
    Docker
    Sketch
    Bootstrap
    C
    Python
    Java
    Git
    MongoDB
    Tailwind
    ViteJS
    MySQL
    PostgreSQL
    Numpy
    Pytorch
    Tensorflow
*/
